import { tracked } from '@glimmer/tracking';

import type { ValidationError, ValidationErrors } from 'webapp-types';
import { validateByRules, type ValidationRule } from 'webapp/utils/validate';

import Serviced from 'webapp/models-custom/serviced';

export default class Validator extends Serviced {
	get validationRules(): Record<string, ValidationRule[]> {
		return {};
	}

	@tracked errors: ValidationErrors<string> = {};

	getValidationErrors(onlyFields?: string[]): ValidationErrors<string> {
		const rules = this.validationRules,
			errors: ValidationErrors<string> = {};

		Object.keys(rules).forEach((field: string) => {
			if (!onlyFields || onlyFields.includes(field)) {
				const err = validateByRules(this, rules[field]!, field);
				if (err[field]) {
					errors[field] = err[field];
				}
			}
		});

		return errors;
	}

	setValidationErrors(errors: ValidationErrors<string> = {}, partial = false): void {
		if (!partial) {
			this.errors = {};
		}

		Object.keys(errors).forEach((errorField) => {
			this.errors[errorField] = errors[errorField]!;
		});

		// trigger update for tracked
		this.errors = this.errors;
	}

	validate(onlyFields?: string[]): boolean {
		if (onlyFields) {
			onlyFields.forEach((field) => {
				if (this.errors[field]) {
					delete this.errors[field];
				}
			});
		} else {
			this.errors = {};
		}

		const errors = this.getValidationErrors(onlyFields);

		this.setValidationErrors(errors, true);

		return !this.errorsArray.length;
	}

	get errorsArray(): ValidationError[] {
		const errorsArray: ValidationError[] = [];
		Object.keys(this.errors).forEach((key) => {
			if (this.errors[key]) {
				errorsArray.push({
					name: key,
					message: this.errors[key][0]!.message,
				});
			}
		});
		return errorsArray;
	}
}
